/* global areGoogleMapsAlreadyLoaded, includeGoogleMapsAsynchronously */

import debounce from 'lodash/debounce';
import { tns } from 'tiny-slider/src/tiny-slider';
import fetchStateFromHtml from '@PROJECT_ROOT/assets/shared/js/fetchStateFromHtml';
import initSearchForms from '@PROJECT_ROOT/assets/desktop/js/welcome/searchForms';
import initPrivateSearchForm from '@PROJECT_ROOT/assets/desktop/js/search/private/privateSearchForm';
import initLighthouseSearchForm from '@PROJECT_ROOT/assets/desktop/js/search/lighthouse/lighthouseSearchForm';
import initCharterSearchForm from '@PROJECT_ROOT/assets/desktop/js/search/charter/charterSearchForm';
import initGoogleAnalyticsEvents from '@PROJECT_ROOT/assets/desktop/js/welcome/googleAnalytics';
import initSearchByIdentificatorForm from '@PROJECT_ROOT/assets/shared/js/PrivateAccommodation/searchByIdentificatorForm';

window.googleMapsLoadedForSimpleForm = new Promise((resolve) => {
    window.googleMapsApiLoadedCallback = resolve;
});

$(() => {
    const state = fetchStateFromHtml();

    initSliders();
    evenGuideArticlesCards();

    initSearchByIdentificatorForm();
    initSearchForms(state);
    initPrivateSearchForm(state);
    initLighthouseSearchForm(state);
    initCharterSearchForm(state);

    loadGoogleMaps(state.googleMapsJsApiUrl);

    initGoogleAnalyticsEvents();
});

function loadGoogleMaps(googleMapsJsApiUrl) {
    if (areGoogleMapsAlreadyLoaded()) {
        window.googleMapsApiLoadedCallback();
    } else {
        includeGoogleMapsAsynchronously(googleMapsJsApiUrl);
    }
}

function initSliders() {
    tns({
        container: '#topDestinations',
        loop: true,
        lazyload: true,
        lazyloadSelector: '.js-lazyLoad',
        gutter: 10,
        items: 2,
        nav: false,
        responsive: {
            600: {
                edgePadding: 0,
                gutter: 5,
                items: 3,
            },
            800: {
                edgePadding: 10,
                items: 4,
            },
            1024: {
                edgePadding: 10,
                items: 4,
            },
            1366: {
                edgePadding: 10,
                gutter: 15,
                items: 6,
            },
        },
    });

    tns({
        container: '#references',
        loop: true,
        lazyload: true,
        lazyloadSelector: '.js-lazyLoad',
        items: 2,
        gutter: 5,
        slideBy: 1,
        navPosition: 'bottom',
        responsive: {
            600: {
                edgePadding: 0,
                items: 2,
            },
        },
    });

    tns({
        container: '#guideAndBlogArticles',
        loop: true,
        lazyload: true,
        lazyloadSelector: '.js-lazyLoad',
        items: 3,
        gutter: 20,
        slideBy: 1,
        nav: false,
        edgePadding: 50,
        responsive: {
            1024: {
                edgePadding: 25,
                items: 3,
            },
            1365: {
                edgePadding: 30,
                items: 4,
            },
            1366: {
                edgePadding: 0,
                gutter: 5,
                items: 5,
            },
        },
    });
}

/**
 * Izjednačavanje visina guide kartica.
 */
function evenGuideArticlesCards() {
    const guideArticlesList = document.getElementById('guideAndBlogArticles');
    const guideArticles = document.querySelectorAll('#guideAndBlogArticles li');
    let guideArticlesListHeight = guideArticlesList.clientHeight;
    setGuideArticlesHeight();

    window.addEventListener('resize', debounce(() => {
        guideArticlesListHeight = guideArticlesList.clientHeight;
        setGuideArticlesHeight();
    }, 200));

    function setGuideArticlesHeight() {
        guideArticles.forEach((elem) => {
            const element = elem;
            element.style.cssText = `height: ${guideArticlesListHeight}px`;
        });
    }
}
